import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useParams, useSearchParams } from 'react-router-dom';
import { useGetStudentSessionReportBySessionIdMutation, useGetStudentSessionReportMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useReportContext } from '../../../../../reports/components/reportContext';
import ActivityTypes from '../../../../../../enums/activityTypes';

const StudentSessionReport = () => {
  const [searchParams] = useSearchParams();
  const [getStudentSessionsReport] = useGetStudentSessionReportMutation();
  const [getStudentSessionsReportBySessionId] = useGetStudentSessionReportBySessionIdMutation();
  const reportContext = useReportContext();
  var studentToIncludeTab = parseInt(searchParams.get('studentsToInclude'));
  var assessmentReportType = parseInt(searchParams.get('assessmentReportType'));
  var isSelfStudy = Boolean(searchParams.get('isSelfStudy'));
  const isTeacherReport = !isNaN(parseInt(studentToIncludeTab, 10));
  const {activityType = ActivityTypes.Assignment} = useParams();

  const getReportTitle = () =>{
    if(reportContext)
    {
      if(reportContext.isAssessment)
        return 'Student- Single Assessment Report';
      else
        return 'Student- Single Assignment Report';
    }
    else
    {
      if(assessmentReportType == 1)
        return 'Single Assessment Report';
      else
        return 'Student Session Report';
    }
  };

  var headerOptions = {
    reportTitle: getReportTitle(),
    showClassDropdown: false,
    showTeacherName: false,
    showStudentName: true,
    showClassName: false,
    isAllStudentReport: false,
    showRetryInfo: true,
    showTotalRow: false,
    showReportType: true,
    reportType: 'Session',
    isAssessment:assessmentReportType > 0 || activityType == ActivityTypes.Assessment,
    isSelfStudy: isSelfStudy
  };

  return (
    <QuestionBreakdownReport
      isRetakeReport={false}
      studentId={searchParams.get('studentId')}
      reportTitle={getReportTitle()}
      exportFileName='StudentSessionReport'
      reportDataEndpoint={isSelfStudy ? getStudentSessionsReportBySessionId : getStudentSessionsReport}
      individualResultsOrientation='vertical'
      headerOptions={headerOptions}
      isTeacherReport={isTeacherReport}
      studentToIncludeTab={studentToIncludeTab}
      goBackOnError={true}
      reportOptions={{ hideDisplayNotStartedStudents: true }}
    />
  );

};

export default StudentSessionReport;